import React from 'react'
import logo from '../Assets/logo.png'
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import './styles.css'
import Search from './Search'
import StyledButton from './StyledButton'

function Form({panTo,selectOrigin,selectDestination,directionsData}) {
   const companyAddress = 'Condomínio Edifício Garcia D Avila - Av. Tancredo Neves, 1543 - Pituba, Salvador - BA, Brasil'
   const [isRouteSelected,setIsRouteSelected] = React.useState(false)
   const [possibleOrigin,setPossibleOrigin] = React.useState('')
   const [possibleDestination,setPossibleDestination] = React.useState('')
   
   
   React.useEffect(()=>{
     
     if(directionsData){
     setIsRouteSelected(true)
     }
   },[directionsData])
   
   
   function buildRouteOnSelect(e){
       
       setPossibleDestination(e)
       console.log(e)
       if (possibleOrigin !== '' && e !== ''){
        selectOrigin(possibleOrigin)
        selectDestination(e)
       }
   }
   
   function reset(){
    setIsRouteSelected(false)
    selectOrigin('')
    selectDestination('')
    setPossibleDestination('')
    setPossibleOrigin('')
    
   }
  
   return (
   <>{ 
     
    (!isRouteSelected)?
        (<div className = 'form-group'>
          <img src = {logo} alt = 'logo' style = {{maxWidth:'150px', display:'block',margin:'0 auto'}}/>
          <Search panTo = {panTo} placeholder = {'busque o destino de origem'} selectPlace = {setPossibleOrigin} defaultValue = {companyAddress}/>
          <Search panTo = {panTo} placeholder = {'busque o destino final'} selectPlace = {buildRouteOnSelect} />
          {/* <StyledButton onClick = {buildRouteOnClick}>Contruir Rota</StyledButton> */}
        </div>): <div className = 'return-button-container'><IconButton onClick = {reset} style = {{background:'#ffffff'}}><ArrowBackIcon style = {{color:'#01213C'}}/></IconButton></div>

    }</>
    )
}

export default Form
